import { defineComponent as _defineComponent } from 'vue';
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";
import { faStar, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useActivityStore } from "@/stores/activityStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivitySettings',
    props: {
        activityBarId: null,
        query: null
    },
    emits: ["activityClicked"],
    setup(__props, { emit }) {
        const props = __props;
        const activityStore = useActivityStore(props.activityBarId);
        const optionalActivities = computed(() => activityStore.activities.filter((a) => a.optional));
        const filteredActivities = computed(() => {
            var _a;
            if (((_a = props.query) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const queryLower = props.query.toLowerCase();
                const results = optionalActivities.value.filter((a) => {
                    const attributeValues = [a.title, a.description];
                    for (const value of attributeValues) {
                        if (value.toLowerCase().indexOf(queryLower) !== -1) {
                            return true;
                        }
                    }
                    return false;
                });
                return results;
            }
            else {
                return optionalActivities.value;
            }
        });
        const foundActivities = computed(() => {
            return filteredActivities.value.length > 0;
        });
        function onFavorite(activity) {
            if (activity.optional) {
                activity.visible = !activity.visible;
            }
        }
        function onRemove(activity) {
            activityStore.remove(activity.id);
        }
        const router = useRouter();
        function executeActivity(activity) {
            if (activity.click) {
                emit("activityClicked", activity.id);
            }
            if (activity.panel) {
                activityStore.toggleSideBar(activity.id);
            }
            if (activity.to) {
                router.push(activity.to);
            }
        }
        return { __sfc: true, props, emit, activityStore, optionalActivities, filteredActivities, foundActivities, onFavorite, onRemove, router, executeActivity, faStarRegular, faStar, faTrash, FontAwesomeIcon };
    }
});
